import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./Checkbox.scss";

export const Checkbox = ({
  value = false,
  onChange,
  label = "",
  className,
}) => {
  return (
    <div className={classNames("checkbox-container", className)}>
      <label className="container">
        {label}
        <input
          type="checkbox"
          checked={value}
          onChange={(v) => onChange(v.target.checked)}
        />
        <span className="checkmark"></span>
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};
